<div class="modal-body py-2">
  <!-- Header with Close X -->
  <div class="d-flex justify-content-between align-items-center w-100 mb-2">
    <div></div>
    <button type="button" class="btn p-0 font-large-1" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <!-- Video Player Section -->
  <div *ngIf="selectedVideoUrl" class="mb-2">
    <video width="100%" controls style="border-radius: 6px;" [poster]="selectedThumbnail">
      <source [src]="selectedVideoUrl" type="video/mp4" />
      Your browser does not support the video tag.
    </video>

  </div>

  <!-- Contact Info -->
  <div class="d-flex flex-column align-items-center support-numbers mt-1">
    <p class="text-center mb-1 font-medium-1">Having trouble? Reach out to us:</p>
    <div class="d-flex align-items-center">
      <div class="d-flex align-items-center">
        <img (click)="copyPhoneNumber('0709953000')" src="../../../../assets/img/phn.png" height="18" alt="">
        <p class="mb-0 text-primary mr-3 font-medium-1" style="margin-left: 0.7rem;">0709953000</p>
      </div>
      <div class="d-flex align-items-center">
        <img (click)="copyPhoneNumber('0798666000')" src="../../../../assets/img/whatsap.png" height="18" alt="">
        <p class="mb-0 text-primary  font-medium-1" style="margin-left: 0.7rem;">0798666000</p>
      </div>
    </div>
  </div>
</div>